var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"m-operate flex-between-center"},[_c('div',{key:"normal",staticClass:"m-operate-group flex-center-cross"},[_vm._t("default")],2),_c('div',{staticClass:"m-operate-group flex-center-cross"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }